import { getters } from '/@/modules/core/app/helpers/store';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class MembersRouteConfig extends CurrentEstateRouteConfig {
  canAccessRoute(): boolean {
    const user: AuthUser | null = getters.auth.getUser();

    return !!user?.permission.canAccessMembersPage;
  }
}
